<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="PRODUCTION LINE">
          <template slot="actions">
            <vs-button v-can="'create-edit-production-lines'" @click="onClickProductionLine" class="mr-4 mb-4" color="primary" type="filled">Create</vs-button>
          </template>
          <div v-can="'view-production-lines'" slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table
              id="sundry-item-list-table"
              :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="items"
              sort
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="10%"  class="text-xs" sort-key="sundry_item_code">PRODUCTION LINE CODE</vs-th>
                <vs-th width="10%"  class="text-xs" sort-key="sundry_product_code">PRODUCTION LINE NAME</vs-th>
                <vs-th width="10%" class="text-xs">TYPE</vs-th>
                <vs-th width="10%" class="text-xs">MAX CAPACITY (L)</vs-th>
                <vs-th width="15%" class="text-xs">MAX CAPACITY (KG)</vs-th>
<!--                <vs-th width="15%" class="text-xs">CLEAN TIME (Mins)</vs-th>-->
                <vs-th width="15%" class="text-xs">STATUS</vs-th>
                <vs-th width="15%" class="text-xs">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr  class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].production_line_code">
                    {{ data[indextr].production_line_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].production_line_name">
                    {{ data[indextr].production_line_name}}
                  </vs-td>

                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].type}}
                  </vs-td>

                  <vs-td :data="data[indextr].max_capacity_ltr">
                    {{ data[indextr].max_capacity_ltr}}
                  </vs-td>

                  <vs-td class="font-bold" :data="data[indextr].max_capacity_kg">
                    {{ data[indextr].max_capacity_kg}}
                  </vs-td>

<!--                  <vs-td class="font-bold" :data="data[indextr].clean_time_between_uses">-->
<!--                    {{ data[indextr].clean_time_between_uses}}-->
<!--                  </vs-td>-->

                  <vs-td class="font-bold" :data="data[indextr].status.name" v-can="'create-edit-production-lines'">


                    <vs-dropdown  vs-trigger-hover class="cursor-pointer">
                      <a class="flex items-center text-dark ml-1" href="#">
                        <vs-chip style="border-radius: 0" class="text-center text-xs" transparent :color="production_line_statuses.find((n) => n.id === data[indextr].status.id).color">
                          {{ data[indextr].status.name}}
                        </vs-chip>
                        <i class="material-icons"> expand_more </i>
                      </a>
                      <vs-dropdown-menu>
                        <vs-dropdown-item class="w-64"
                                          @click.stop="onClickChangeItemStatus(data[indextr].id, status.url)"
                                          v-for="status in production_line_statuses"
                                          v-if="data[indextr].status.name !== status.name"
                                          v-bind:key="status.name">
                          {{status.name}}
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>



                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button  class="ml-3"
                                   @click.stop="onClickUpdateProductionLine(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
    <create-production-line-pop-up ref="createProductionLinePopUp" />
    <update-production-line-pop-up ref="updateProductionLinePopUp" />
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const ManufacturingRepository = RepositoryFactory.get('manufacturing')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "@/constants/config";
  import CreateProductionLinePopUp from "@/components/popups/manufacturing/production-line/CreateProductionLinePopUp.vue";
  import UpdateProductionLinePopUp from "@/components/popups/manufacturing/production-line/UpdateProductionLinePopUp.vue";
  import {production_line_statuses} from '@/constants/statuses'


  export default {
    name: 'ProductionLineList',
    data () {
      return {
        items: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
        activePrompt: false,
        current_stock_level: '',
        selected_product_id: '',
        production_line_statuses: production_line_statuses
      }
    },
    components: {
      'v-select': vSelect,
      CreateProductionLinePopUp,
      UpdateProductionLinePopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      await this.getProductionLineStatus()
    },
    methods: {
      async refreshData () {
        this.fetchSundryItemStockList()
      },
      async fetchSundryItemStockList() {
        await this.$vs.loading({
          container: '#sundry-item-list-table',
          scale: 0.45
        })
        try {
          const {data} = await ManufacturingRepository.getProductionLineList(this.page, this.filterQuery, this.perPage)
          this.items =  data.data
          this.meta = data.meta
        } catch (e) {
          this.showWarningMessage('Something went wrong. Please try again!')
        }
        this.$vs.loading.close('#sundry-item-list-table > .con-vs-loading')
      },
      // async getProductionLineStatus (){
      //   try {
      //     const {data} = (await ManufacturingRepository.getProductionLineStatus({is_active: true})).data
      //     this.production_line_statuses = data
      //   }catch (e) {
      //     this.convertAndNotifyError(e)
      //   }
      // },
      async onClickChangeItemStatus(id, status) {
        await this.$vs.loading({
          container: '#sundry-item-list-table',
          scale: 0.45
        })
        try {
          await ManufacturingRepository.statusChangeProductionLine(id, status)
          await this.fetchSundryItemStockList()
        } catch (e) {
          this.showWarningMessage('Something went wrong. Please try again!')
        }
        this.$vs.loading.close('#sundry-item-list-table > .con-vs-loading')
      },
      filterQueryUpdate (){
        this.fetchSundryItemStockList()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchSundryItemStockList()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchSundryItemStockList()
        }

      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      close(){
        this.activePrompt = false
      },
      onClickProductionLine() {
        this.$refs.createProductionLinePopUp.openPopup()
      },
      onClickUpdateProductionLine(id) {
        this.$refs.updateProductionLinePopUp.openPopup(id)
      },
      productionLineStatusColorFactory(name) {
        const colors = [{name: 'Live', color: 'primary'}, {name: 'Offline for Maintenance', color: 'danger'},
          {name: 'Obsolete', value: 'dark'}, {name: 'Pre-Deployment Stage', color: 'warning'}]
        return colors.find((n) => n.name === name).color
      }
    },
    watch : {
      page(){
        this.fetchSundryItemStockList()
      },
      perPage() {
        this.fetchSundryItemStockList()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
